import CTALink from "../CTA/ctaLink";
import Icon from "@/components/icons";

export interface ShowcaseCardProps {
  header: string;
  subheader: string;
  headerBackgroundColor: "putty" | "putty-light" | "fern" | "fern-light";
  headerIcon: "book-open" | "business" | "certificate" | "school";
  factoids: {
    text: string;
    icon: "trending-up" | "certificate" | "timelapse";
  }[];
  cta: {
    text: string;
    url: string;
  };
  hideFactoidsOnMobile: boolean;
  location?: string;
  position?: number;
}

export default function ShowcaseCard({
  headerBackgroundColor,
  header,
  subheader,
  headerIcon,
  factoids,
  cta,
  hideFactoidsOnMobile,
  location,
  position,
}: ShowcaseCardProps) {
  const backgroundColorMap = {
    putty: "bg-putty-500",
    "putty-light": "bg-putty-200",
    fern: "bg-secondary-200",
    "fern-light": "bg-secondary-100",
  };

  return (
    <div className="w-full max-w-[300px] border border-putty rounded-xl overflow-y-hidden h-full grid grid-rows-[auto_1fr_auto]">
      {/* Header section - fixed height */}
      <div
        className={`py-6 px-3 flex flex-col ${backgroundColorMap[headerBackgroundColor] || backgroundColorMap.putty} w-full gap-4 md:h-44`}
      >
        <div className="flex items-center gap-4">
          <div className="w-[55px] h-[55px] p-[10px] bg-white rounded-full flex items-center justify-center">
            <Icon
              type={headerIcon}
              svgProps={{ width: "35", height: "35" }}
              pathProps={{ fill: "#00262b" }}
            />
          </div>
          <div className="text-lg md:text-xl font-semibold md:w-1/2 leading-tight text-primary-500">
            {header}
          </div>
        </div>
        <p className="text-base text-primary-500">{subheader}</p>
      </div>

      {/* Factoids section - flexible height */}
      <div
        className={`pt-6 pb-4 px-3 ${hideFactoidsOnMobile ? "hidden" : "flex"} md:flex flex-col justify-between`}
      >
        <div className={`flex flex-col gap-4`}>
          {factoids.map((factoid, index) => (
            <div key={index} className="flex gap-3 items-start">
              <div className="w-7 h-7 mt-0.5 flex-shrink-0">
                <Icon
                  type={factoid.icon}
                  svgProps={{ width: "28", height: "28" }}
                  pathProps={{ fill: "#00262b" }}
                />
              </div>
              <div className="text-md">{factoid.text}</div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA section - fixed to bottom */}
      <div
        className={`${hideFactoidsOnMobile ? "mt-6 md:mt-0" : ""} mb-6 px-4`}
      >
        <CTALink
          url={cta.url}
          label={cta.text}
          type="default"
          className="w-full elm-p3 text-nowrap"
          location={location}
          html_id={`cta-${header}`}
          position={position}
        />
      </div>
    </div>
  );
}
